import { combineReducers, configureStore } from '@reduxjs/toolkit';
import OtsAircraftSlice from './feature/OtsAircraftSlice';
import EventTypeSlice from './feature/EventTypeSlice';
import EventTypesSlice from './feature/EventTypesSlice';
import OpenEventsListSlice from './feature/OpenEventsListSlice';
import FlightScheduleSlice from './feature/FlightScheduleSlice';
import FilterSortSlice from './feature/FilterSortSlice';
import ClosedFilterSortSlice from './feature/ClosedFilterSortSlice';
import  ViewSlice  from './feature/ViewSlice';

import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist'
// indicates the redux store will be persisted to local storage 
import storage from 'redux-persist/lib/storage'

// Define the root reducer
const rootReducer = combineReducers({
    eventType: EventTypeSlice.reducer,
    otsAircraft: OtsAircraftSlice.reducer, 
    eventTypes: EventTypesSlice.reducer,
    openEvents: OpenEventsListSlice.reducer,
    flightPath: FlightScheduleSlice.reducer,
    filterSort: FilterSortSlice.reducer,
    closedFilterSort: ClosedFilterSortSlice.reducer,
    view: ViewSlice.reducer,
  });

const persistConfig = {
    key: 'otsRoot',
    version: 1,
    storage,
    debug: true,
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});
const persistor = persistStore(store);
export { store, persistor };